import PlaylistAddCheckOutlined from '@mui/icons-material/PlaylistAddCheckOutlined';
import { s } from '../../format/schema';
import { defineFieldType, optionSettings, selectedOptionIds } from '../card';
import { MultiselectInput } from './FillInput';

export const multiselect = defineFieldType({
  type: 'multiselect',
  name: 'Multiselect',
  valueKind: 'options',
  settings: s.strictObject({ ...optionSettings }),
  defaults: {},
  value: selectedOptionIds,
  emptyValue: [],
  hasDefaultValue: true,
  validations: ['required', 'range'],
  operators: ['isFilled', 'isEmpty', 'anyOf', 'noneOf', 'allOf'],
  palette: [
    {
      name: 'Multiselect',
      tooltip: 'Several options from a dropdown',
      group: 'Choice',
      icon: PlaylistAddCheckOutlined,
    },
  ],
  isEmpty: value => value.length === 0,
  quantity: value => value.length,
  comparable: value => value,
  FillInput: MultiselectInput,
});
